import './styles.css';
import './language.css';

const language = document.documentElement.lang;
const ui = language === 'zh-Hans'
  ? { copied: '已复制', copy: '复制邮箱', dev: '开发预览' }
  : language === 'es'
    ? { copied: 'Copiado', copy: 'Copiar correo', dev: 'Vista de desarrollo' }
    : { copied: 'Copied', copy: 'Copy email', dev: 'Dev preview' };

document.querySelectorAll<HTMLDetailsElement>('.language-picker').forEach(picker => {
  picker.querySelectorAll<HTMLAnchorElement>('a[data-language]').forEach(link => {
    link.href += window.location.search + window.location.hash;
  });
  document.addEventListener('click', event => {
    if (event.target instanceof Node && !picker.contains(event.target)) picker.open = false;
  });
  picker.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      picker.open = false;
      picker.querySelector('summary')?.focus();
    }
  });
});

const year = document.querySelector<HTMLSpanElement>('#year');
if (year) {
  year.textContent = new Date().getFullYear().toString();
}

const environmentPill = document.querySelector<HTMLSpanElement>('.environment-pill');
const isDevHost = window.location.hostname === 'dev.logpie.com'
  || window.location.hostname.startsWith('dev.')
  || import.meta.env.VITE_SITE_ENV === 'dev';

if (environmentPill && isDevHost) {
  environmentPill.hidden = false;
  environmentPill.textContent = ui.dev;
}

const copyButtons = document.querySelectorAll<HTMLButtonElement>('[data-copy-email]');
copyButtons.forEach((copyButton) => {
  const defaultText = copyButton.textContent ?? ui.copy;
  copyButton.addEventListener('click', async () => {
    const email = copyButton.dataset.copyEmail ?? '';
    copyButton.textContent = ui.copied;
    window.setTimeout(() => {
      copyButton.textContent = defaultText;
    }, 1800);

    try {
      await navigator.clipboard.writeText(email);
    } catch {
      window.location.href = `mailto:${email}`;
    }
  });
});
